import {
  ADD_CONTACT,
  GET_CONTACT,
  ADD_ACTION,
  GET_ACTION,
  GET_ACTIONS,
  ADD_DEAL,
  GET_DEALS,
  GET_CONTACTS,
  DELETE_ACTION,
  DELETE_DEAL,
  LOGOUT,
  DELETE_CONTACT
} from '../actions/types';
const initialState = {
  contact: null,
  contacts: [],
  action: null,
  actions: [],
  deal: null,
  deals: []
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_CONTACT:
    case ADD_ACTION:
    case ADD_DEAL:
    case GET_CONTACT:
    case DELETE_ACTION:
    case DELETE_DEAL:
      return {
        ...state,
        contact: payload
      };
    case GET_CONTACTS:
      return {
        ...state,
        contacts: payload
      };
    case GET_ACTION:
      return {
        ...state,
        action: payload
      };
    case GET_ACTIONS:
      return {
        ...state,
        actions: payload
      };
    case GET_DEALS:
      return {
        ...state,
        deals: payload
      };
    case DELETE_CONTACT:
      return {
        ...state,
        contact: null
      };
    case LOGOUT:
      return {
        ...state,
        contact: null,
        contacts: [],
        action: null,
        actions: [],
        deal: null,
        deals: []
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contact.js